module.exports = __webpack_public_path__ + "static/media/locate-plus-logo.080358e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/locate-plus-logo.png
// module id = 1902
// module chunks = 0